import { ADVERTISERS } from './advertiser.navigation';
import AdvertiserList from './AdvertiserList';

const ADVERTISER_ROUTE = { ...ADVERTISERS, component: AdvertiserList };

export default ADVERTISER_ROUTE;
